import { createAction } from '@reduxjs/toolkit';

import types from '../actionTypes';

export const exportRequest = createAction(types.EXPORT_REQUEST);
export const exportRequestSuccess = createAction(types.EXPORT_REQUEST_SUCCESS);
export const exportRequestFailure = createAction(types.EXPORT_REQUEST_FAILURE);
